import { Table } from "@mantine/core";
import { RefundHistoryModel, ReturnFeeHistoryModel, ReturnFeeHistoryOrderItemModel } from "./types";
import moment from "moment";

interface IRefundHistoryTableProps {
  refundHistoryModels: RefundHistoryModel[];
  returnFeeHistoryModels: ReturnFeeHistoryModel[];
}

export const RefundHistoryTable = ({
  refundHistoryModels,
  returnFeeHistoryModels,
}: IRefundHistoryTableProps) => {
  return (
    <>
      <Table withBorder withColumnBorders striped>
        <thead>
          <tr className="bg-light">
            <th>Date</th>
            <th>Order No.</th>
            <th>Refund Amount</th>
            <th>Payment Method</th>
            <th>Summary</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {refundHistoryModels &&
            refundHistoryModels.map((refundOrder: any, index: number) => (
              <tr key={index}>
                <td>
                  {moment(refundOrder.TransactionDate).format(
                    "DD/MM/YYYY hh:mm:ss A",
                  )}
                </td>
                <td>
                  {refundOrder.RefundHistoryOrderItemModels.map(
                    (bidDeal: any, b_index: number) => (
                      <span key={b_index}>
                        {bidDeal.BidDealId}
                        <br />
                      </span>
                    ),
                  )}
                </td>
                <td>
                  {refundOrder.RefundHistoryOrderItemModels.map(
                    (bidDeal: any, b_index: number) => (
                      <span key={b_index}>
                        {bidDeal.CustomerPrice.toFixed(2)}
                        <br />
                      </span>
                    ),
                  )}
                </td>
                <td>{refundOrder.PaymentMethod}</td>
                <td>
                  <strong>{refundOrder.RefundReason}</strong>
                  <div style={{ wordBreak: "break-word" }}>
                    {refundOrder.RefundNoteContent}
                  </div>
                </td>
                <td>{refundOrder.Approved ? "Approved" : "Processing"}</td>
              </tr>
            ))}
          {returnFeeHistoryModels &&
            returnFeeHistoryModels.map((returnFeeOrder: ReturnFeeHistoryModel, index: number) => (
              <tr key={index}>
                <td>
                  {moment(returnFeeOrder.TransactionDate).format(
                    "DD/MM/YYYY hh:mm:ss A",
                  )}
                </td>
                <td>
                  {returnFeeOrder.ReturnFeeHistoryOrderItemModels.map(
                    (bidDeal: ReturnFeeHistoryOrderItemModel, b_index: number) => (
                      <span key={b_index}>
                        {bidDeal.BidDealId}
                        <br />
                      </span>
                    ),
                  )}
                </td>
                <td>
                  {returnFeeOrder.ReturnFeeHistoryOrderItemModels.map(
                    (bidDeal: ReturnFeeHistoryOrderItemModel, b_index: number) => (
                      <span key={b_index}>
                        {bidDeal.CustomerPrice.toFixed(2)}
                        <br />
                      </span>
                    ),
                  )}
                </td>
                <td>{returnFeeOrder.PaymentMethod}</td>
                <td>
                  <strong>{returnFeeOrder.ReturnFeeReason}</strong>
                  <div style={{ wordBreak: "break-word" }}>
                    {returnFeeOrder.ReturnFeeNoteContent}
                  </div>
                </td>
                <td>{returnFeeOrder.Approved ? "Approved" : "Processing"}</td>
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );
};
